module.exports = "mat4 scale(vec3 s) {\nreturn mat4(\ns.x, 0, 0, 0,\n0, s.y, 0, 0,\n0, 0, s.z, 0,\n0, 0, 0, 1\n);\n}"